__webpack_require__.p = "/neural-cellular-automata/";